import EZAxios from '@/ezaxios';
import Axios from 'axios';
import store from '@/store';

// Fast scraper API config
var FAST_SCRAPER_URL = 'https://api.ezai.io/file:website/website-preview';
var FAST_SCRAPER_TOKEN = '0UWlVjvc5LllVjvc66e418698132706ed14e451610eda581';

export default {
  getAllPages() {
    return EZAxios.get(`custom-pages?skipBody=1`);
  },
  getPage(id, admin = 0) {
    return EZAxios.get(`custom-page/${id}?admin=${admin}`);
  },
  addPage(data = {}) {
    return EZAxios.post(`admin/custom-page`, data, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token') || sessionStorage.getItem('token')}`,
        'Business-Slug': store.state.business_slug
      }
    });
  },
  updatePage(data = {}) {
    return EZAxios.post(`admin/update-custom-page`, data, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token') || sessionStorage.getItem('token')}`,
        'Business-Slug': store.state.business_slug
      }
    });
  },
  deletePage(id) {
    return EZAxios.post(`/admin/custom-page/delete/${id}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token') || sessionStorage.getItem('token')}`,
        'Business-Slug': store.state.business_slug
      }
    });
  },

  // AI Custom Page methods
  previewAICustomPage(data = {}) {
    // Use fast scraper API directly
    var formData = new FormData();
    formData.append('url', data.url);
    formData.append('nocache', '1');
    formData.append('fullpagescreenshot', '0');
    formData.append('noscreenshot', '1');
    formData.append('aicopier', '1');

    return Axios.post(FAST_SCRAPER_URL, formData, {
      timeout: 30000, // 30 seconds should be plenty for fast scraper
      headers: {
        'x-Auth-Token': FAST_SCRAPER_TOKEN
      }
    }).then(function(response) {
      // Transform response to match expected format
      var scraped = response.data;
      return {
        data: {
          success: scraped.success === 1,
          data: {
            html: null, // No AI generation yet
            title: scraped.title || '',
            meta_title: scraped.title || '',
            meta_description: scraped.description || '',
            suggested_link: (scraped.title || '').toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, ''),
            source_url: scraped.url,
            screenshot_url: null,
            tags: scraped.tags || [],
            scraped_info: {
              title: scraped.title,
              has_screenshot: false,
              text_length: (scraped.tags || []).join(' ').length,
              meta_count: (scraped.metas || []).length
            },
            tokens_used: null,
            // Pass raw scraped data for AI generation step
            _scraped: scraped
          }
        }
      };
    });
  },

  buildAICustomPage(data = {}) {
    return EZAxios.post(`admin/ai-custom-page/build`, data, {
      timeout: 180000, // 3 minutes for AI generation
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token') || sessionStorage.getItem('token')}`,
        'Business-Slug': store.state.business_slug
      }
    });
  },

  extractFromFile(file) {
    var formData = new FormData();
    formData.append('file', file);

    return EZAxios.post(`admin/ai-custom-page/extract-from-file`, formData, {
      timeout: 60000, // 60 seconds for file processing
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token') || sessionStorage.getItem('token')}`,
        'Business-Slug': store.state.business_slug,
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  addToExistingPage(data = {}) {
    return EZAxios.post(`admin/ai-custom-page/add-to-existing`, data, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token') || sessionStorage.getItem('token')}`,
        'Business-Slug': store.state.business_slug
      }
    });
  },

  sendMemberEmail(pageId, email, password) {
    return EZAxios.post(`admin/custom-page/${pageId}/send-member-email`, { email, password }, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token') || sessionStorage.getItem('token')}`,
        'Business-Slug': store.state.business_slug
      }
    });
  }
};
